export default __webpack_public_path__ + "static/media/gt.d5b96f95.png";